import Macy from 'macy';

class PageNavigation {

    element;
    dropdownMenuItems;
    subMenuItemsWithChildren;
    macyInstances;
    constructor(element) {

        if (!(element instanceof HTMLElement)) {
            throw new TypeError("Invalid HTMLElement");
        }

        this.element = element;
        this.dropdownMenuItems = this.element.querySelectorAll('.menu-item-has-children > .menu-item.menu-item-heading') ?? [];
        this.subMenuItemsWithChildren = this.element.querySelectorAll('.sub-menu .menu-item-has-children > a') ?? [];
        this.twoColumnMenus = this.element.querySelectorAll('.menu.menu-column-2') ?? [];
        this.macyInstances = [];

        this.initSubMenuToggle();
        this.initInnerMenuDropdown();
        this.initInnerMenuMacy();
    }

    // Toggle SubMenu open/closed
    toggleSubMenu = (e) => {

        const menuItem = e.currentTarget;
        const isAlreadyOpen = menuItem.classList.contains('open');
        //const isMobile = window.innerWidth < 992;

        // Remove open class from all menu items
        this.dropdownMenuItems.forEach(el => el.classList.toggle('open', false));

        menuItem.classList.toggle('open', !isAlreadyOpen);
    }

    initSubMenuToggle = () => {
        this.dropdownMenuItems.forEach(el => el.addEventListener('click', e => {
            this.toggleSubMenu(e);
            this.reinitialiseMacyInInstances(); // Fix for Macy.js initialising with 0px height as the submenu is closed
        }));
    }

    // Toggle Inner SubMenu (open/closed)
    toggleInnerSubMenu = (e) => {
        // Toggle Submenu Item With Children

        //const clickedTarget = e.target;
        //const isClickedTargetLink = clickedTarget.tagName === "A";

        // If clicked target is link without hash
        //  do not change menu state if link was clicked
        // if (isClickedTargetLink && clickedTarget.href) {
        //     const targetUrl = new URL(clickedTarget.href);
        //     if (!targetUrl.hash) {
        //         return;
        //     }
        // }

        e.preventDefault();

        // Class needs to be toggled on the parent element
        const subMenu = e.currentTarget.parentElement;
        const isAlreadyOpen = !subMenu.classList.contains('closed');

        // Close all inner submenus
        this.subMenuItemsWithChildren.forEach(el => el.parentElement.classList.toggle('closed', true));

        // Toggle the clicked item (open/closed)
        subMenu.classList.toggle('closed', isAlreadyOpen);

        this.reinitialiseMacyInInstances();
    }

    initInnerMenuDropdown = () => {
        this.subMenuItemsWithChildren.forEach(el => {

            el.addEventListener('click', this.toggleInnerSubMenu.bind(this));

            // When initialised close submenu
            el.parentElement.classList.toggle('closed', true);
        });
    }

    reinitialiseMacyInInstances = () => {
        // Reinitialise all macy instances
        this.macyInstances.forEach(macy => {
            macy.reInit()
        });
    }

    initInnerMenuMacy = () => {
        this.twoColumnMenus.forEach(el => {
                this.macyInstances.push(new Macy({
                    container: el,
                    trueOrder: true,
                    columns: 2,
                    breakAt: {
                        1000: 1
                    }
                }));
            });
    }
}

export default PageNavigation;
